module.exports = function(x) {
  return (x | 0) === x
}
